import React from 'react';
import { ExpandableMenuProps } from 'src/app/molecules/Header/Header/HeaderLinks';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import ResourcesMegaMenuFeatures from './ResourcesMegaMenuFeatures';
import ResourcesMegaMenuLearnMore from './ResourcesMegaMenuLearnMore';
import { ResourcesMegaMenuSideContainer } from './ResourcesMegaMenu.styles';

const ResourcesMegaMenuSideBar = ({ isOpen }: ExpandableMenuProps): JSX.Element => {
  const menuContainerRef = React.useRef<HTMLDivElement>(null);

  return (
    <ResourcesMegaMenuSideContainer
      isOpen={isOpen}
      maxHeight={menuContainerRef.current?.getBoundingClientRect().height || 0}
    >
      <Stack
        ref={menuContainerRef}
        direction='column'
      >
        <ResourcesMegaMenuFeatures />
        <ResourcesMegaMenuLearnMore />
      </Stack>
    </ResourcesMegaMenuSideContainer>
  );
};

export default ResourcesMegaMenuSideBar;
